var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.112 19.36V22.204H4.78401C4.98921 24.5968 5.83042 26.8911 7.22122 28.8492C8.61202 30.8073 10.5008 32.3578 12.692 33.34C19.22 36.412 27.512 35.188 34.196 29.572L36.812 32.728C32.2472 36.7122 26.4296 38.9674 20.372 39.1C17.1368 39.1059 13.9412 38.3969 11.012 37.024C7.80442 35.5442 5.10202 33.153 3.24322 30.1486C1.38562 27.1442 0.45199 23.6592 0.55999 20.128C0.61039 14.9092 2.70678 9.91864 6.39798 6.22936C10.0892 2.54008 15.0812 0.446918 20.3 0.399998C31.1 0.399998 40.04 9.376 40.04 19.36H40.112ZM35.888 18.16C35.276 10.792 28.688 4.492 20.288 4.492C11.888 4.492 5.312 10.792 4.772 18.16H35.888Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerE);
export default __webpack_public_path__ + "static/media/LOWER_E.2dbb2de044ee36630b79092ce47c629a.svg";
export { ForwardRef as ReactComponent };